document.addEventListener('DOMContentLoaded', () => {
  waitForClarity(syncClarityCustomerId);
});

function waitForClarity(callback, maxAttempts = 50) {
  let attempts = 0;
  const interval = setInterval(() => {
    if (typeof clarity === 'function' || window.clarity) {
      clearInterval(interval);
      callback();
    } else if (++attempts >= maxAttempts) {
      clearInterval(interval);
      console.warn('Clarity library did not load within expected time');
    }
  }, 100);
}

async function syncClarityCustomerId() {
  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    let clarityCustomerId;
    
    if (cart.attributes && cart.attributes.clarity_customer_id) {
      clarityCustomerId = cart.attributes.clarity_customer_id;
    } else {
      clarityCustomerId = cart.token;
      
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            clarity_customer_id: clarityCustomerId
          }
        })
      });
    }
    
    if (window.clarity) {
      window.clarity('identify', clarityCustomerId);
    }
    
  } catch (error) {
    console.error('Error syncing Clarity customer ID:', error);
  }
}
